

















































import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import PaperItem from '@/main-components/papers/PaperItem.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import CollectionStore, {
  CollectionStoreInterface,
} from '@/resource/collection/collection.store';
import { Collection } from '@/resource/collection/collection.model';
import ModalConfirm from '@/main-components/common/modal/ModalConfirm.vue';
import { deleteResource, DeleteResource } from '@/utils/delete-resource';
import PaperItemLoading from '@/main-components/papers/PaperItemLoading.vue';
import { getToken, getUserStatus } from '@/utils/cookie';
import PremiumModal from '@/main-components/premium/PremiumModal.vue';
import { UserStatus } from '@/resource/user/user.model';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    MainButton,
    PaperItem,
    ModalConfirm,
    PaperItemLoading,
    PremiumModal,
  },
  metaInfo(this: Papers): MetaInfo {
    return {
      title: pageSEO.title.binaLatihan,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.binaLatihan,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.binaLatihan,
          description: pageSEO.description.binaLatihan,
        }),
      ],
    };
  },
})
export default class Papers extends Vue {
  paperStore: CollectionStoreInterface = CollectionStore;
  isLoading = true;
  isFirstLoading = true;
  papers: Collection[] = [];
  openDeleteModal: any = null;
  openPremiumModal: any = null;
  toDeletePaperId: string | null = null;

  get isLoggedIn() {
    return getToken() ? true : false;
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  async created() {
    if (!this.isLoggedIn) {
      this.$router.push(`/papers/create`);
    } else {
      await this.fetchPapers();
    }

    this.isFirstLoading = false;
  }

  async fetchPapers() {
    this.isLoading = true;

    await this.paperStore.fetchCollections();

    if (!this.paperStore.error) {
      this.papers = this.paperStore.collections;

      if (!this.papers.length) {
        this.$router.push(`/papers/create?isEmpty=true`);
      }
    }

    this.isLoading = false;
  }

  createNewPaperClicked() {
    if (this.papers.length >= 2 && this.userStatus === UserStatus.Free) {
      this.openPremiumModal && this.openPremiumModal();
    } else {
      this.$router.push({
        path: '/papers/create',
      });
    }
  }

  openDeleteModalAdd(openModal: any) {
    this.openDeleteModal = openModal;
  }

  openPremiumModalAdd(openModal: any) {
    this.openPremiumModal = openModal;
  }

  onDeleleClicked(paperId: string) {
    this.toDeletePaperId = paperId;
    this.openDeleteModal && this.openDeleteModal();
  }

  async onDeleteSubmit() {
    if (this.isLoading || !this.toDeletePaperId) return;

    this.isLoading = true;
    await deleteResource(this.toDeletePaperId, DeleteResource.Collection);
    await this.fetchPapers();

    this.isLoading = false;
  }
}
